import { render, staticRenderFns } from "./Kefu.vue?vue&type=template&id=0dda4611&scoped=true&"
import script from "./Kefu.vue?vue&type=script&lang=js&"
export * from "./Kefu.vue?vue&type=script&lang=js&"
import style0 from "./Kefu.vue?vue&type=style&index=0&id=0dda4611&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda4611",
  null
  
)

export default component.exports